export const htmlToWordsArray = html => (html ? html.replace(/<[^>]*>?/gm, '').split(' ') : []);
